import axios from "@/axios-service";
import { ResponseContent, responseContent, paginatedResponseContent, Page } from "../types";
import { Farm, FarmDTO, FarmListFilter, FarmListRow, FarmsArea, FarmCount, FarmCentroid, FarmMapSummary, SentinelaTableDTO } from "./types";
import { classToPlain, plainToClass } from "class-transformer";
import { buildParams, buildParamsNotPaged } from "..";

const MS_URL = "senana/api/farms";
const responseAsFarms = responseContent(Farm);
const responseAsFarmsArea = responseContent(FarmsArea);
const responseAsFarmsCount = responseContent(FarmCount);
const responseAsFarmMapSummary = responseContent(FarmMapSummary);


export const getFarmsByOwner = async (
  ownerUuid: string
): Promise<ResponseContent<Farm[]>> =>
  axios.get(`${MS_URL}/owner/${ownerUuid}`).then(responseAsFarms);

export const createFarm = async (
  farm: FarmDTO
): Promise<ResponseContent<Farm>> => {
  const url = farm.isFromCarCode ? `${MS_URL}/car` : MS_URL;
  return axios.post(url, classToPlain(farm)).then(responseAsFarms);
}


export const deleteFarm = async (uuid: string) => axios
  .delete(`${MS_URL}/${uuid}`)

export const getFarmList = async (page: Page, filters: FarmListFilter) => {
  const params = buildParams(filters, page);
  return axios
  .get(`${MS_URL}/list`, params )
  .then(response => paginatedResponseContent(response.data, FarmListRow))
}

export const getFarmByUuid = async (
  farmUuid: string
): Promise<ResponseContent<Farm>> =>
  axios.get(`${MS_URL}/${farmUuid}`).then(responseAsFarms);

export const getFarmArea = async ( onlyUserFarms: boolean, onlyActiveMonitoring: boolean
  ): Promise<ResponseContent<FarmsArea>> =>
    axios.get(`${MS_URL}/area`, { params: { onlyUserFarms, onlyActiveMonitoring }}).then(responseAsFarmsArea);

export const getCountFarms = async ( onlyUserFarms: boolean, onlyActiveMonitoring: boolean
  ): Promise<ResponseContent<FarmCount>> =>
    axios.get(`${MS_URL}/count`, { params: { onlyUserFarms, onlyActiveMonitoring }}).then(responseAsFarmsCount);


const responseAsFarmCentroid = responseContent(FarmCentroid);
export const getFarmsCentroids = (filter: FarmListFilter): Promise<ResponseContent<FarmCentroid[]>> => {
  const params = buildParamsNotPaged(filter)
  return axios
  .get(`${MS_URL}/centroidlist`, params)
  .then(responseAsFarmCentroid);
}

export const getFarmMapSummary = async (
  uuid: string
): Promise<ResponseContent<FarmMapSummary>> =>
  axios.get(`${MS_URL}/${uuid}/brief`).then(responseAsFarmMapSummary);

export const getSentinelaTable = async (
  page: number, size: number, sortBy: string, 
  sortDesc: boolean, search: string, cropType: string | undefined, monitoringYear: number | null
  ) => {
  const params = {page, size, sortBy, sortDesc, search, cropType, monitoringYear}
  return axios.get(`${MS_URL}/analysis/sentinela/list`, {params})
  .then(response => paginatedResponseContent(response.data, SentinelaTableDTO)) 
  }


